<template>
  <div class="absolute left-0 w-full tw bg-white print:overflow-hidden" data-cy="clients-page">
    <div class="container tw color-unset lineheight-unset flex flex-col">
      <div class="flex h-full w-full">
        <template v-if="meLoaded">
          <div v-if="permissions?.matters?.create" class="px-4 pb-4 w-full">
            <ClientsTable :state="state" />
          </div>
          <div v-else class="mt-8 w-full text-lg text-center font-semibold text-gray-800">
            You do not have permission to view this page!
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import type { PropType } from 'vue';
import { storeToRefs } from 'pinia';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { useMeStore } from '@/services/UserService/useMeStore';
import type { UiRouterState } from '@/services/RouteService/UiRouterState';
import ClientsTable from './components/ClientsTable.vue';

const props = defineProps({
  state: { type: Object as PropType<UiRouterState>, required: false },
});

const { handleError } = useSnackbarHandler();
const meStore = useMeStore();
const { permissions, features } = storeToRefs(meStore);
const meLoaded = ref(false);

onMounted(async () => {
  try {
    await meStore.getMe();
  } catch (error) {
    handleError(error);
    return;
  }

  // clients2 is the flag-gated list; without the flag, send the user to the same
  // state under the legacy clients root - the two route trees are identical, so a
  // create-client modal opened here survives the redirect.
  if (!features.value?.fizzyLiftingDrink) {
    const current = props.state?.current?.name || 'clients2';
    props.state?.go(current.replace(/^clients2/, 'clients'), props.state?.params);
    return;
  }

  meLoaded.value = true;
});
</script>
